import ViewPickOrder from "../../../../components/@documents/pick_orders/ViewPickOrder";

import {routeTypes} from "../../../../hooks/useSystemRoutes";

export default function PickOrderViewPage() {

    return (
        <ViewPickOrder
            routeType={routeTypes.admin}
        />
    )
}